<template>
  <div>
    <div class="containerFull" style="min-height:600px">
      <div class="p-grid">
        <div class="p-col-12">
          <h2 style="border-bottom: 1px solid #cfcfcf;" class="p-pb-5 p-mt-6 titulo-admin p-ml-2">
            Administración de Artículos del Blog
          </h2>
          <DataTable
            ref="dt"
            :value="itemsList"
            dataKey="id"
            :paginator="true"
            :rows="10"
            :filters="filters"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25]"
            currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} artículos"
            class="p-datatable-responsive-demo p-mt-5"
            style="margin-bottom:100px"
            :loading="loading"
          >
            <template #header>
              <div
                class="table-header"
                style="align-items: center;display: flex;"
              >
                <span class="p-input-icon-left" style="margin-left: auto;">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters['global']"
                    placeholder="Buscar..."
                  />
                </span>
              </div>
            </template>
            <Column field="creador" header="Creador del artículo" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Creador del artículo</span>
                {{ `${slotProps.data.nombres} ${slotProps.data.apellidos}` }}
              </template>
            </Column>
            <Column field="titulo" header="Titulo" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Titulo</span>
                {{ slotProps.data.titulo }}
              </template>
            </Column>
            <Column field="autor" header="Autor" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Autor</span>
                {{ slotProps.data.autor }}
              </template>
            </Column>
            <Column field="resumen" header="Resumen" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Resumen</span>
                {{ slotProps.data.resumen }}
              </template>
            </Column>
            <Column field="referencias" header="Referencias" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Referencias</span>
                {{ slotProps.data.referencias }}
              </template>
            </Column>
            <Column field="activo" header="Activo" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Activo</span>
                {{ slotProps.data.activo == 0 ? "No" : "Si" }}
              </template>
            </Column>
            <Column field="publicado" header="Publicado" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Publicado</span>
                {{ slotProps.data.publicado == 0 ? "No" : "Si" }}
              </template>
            </Column>
            <Column :exportable="false">
              <template #body="slotProps">
                <span class="p-column-title">Acciones</span>
                <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success p-mr-2"
                  @click="revisarItem(slotProps.data)"
                  v-tooltip.top="'Revisar y comentar'"
                  name="editar"
                />
                <Button
                  icon="pi pi-check"
                  class="p-button-rounded p-button-warning"
                  @click="confirmPublicarItem(slotProps.data)"
                  v-if="slotProps.data.publicado == 0"
                  v-tooltip.top="'Publicar'"
                  name="publicar"
                />
                <Button
                  icon="pi pi-times"
                  class="p-button-rounded p-button-warning"
                  @click="confirmDesPublicarItem(slotProps.data)"
                  v-if="slotProps.data.publicado == 1"
                  v-tooltip.top="'Dejar de hacer publico'"
                  name="despublicar"
                />
              </template>
            </Column>
          </DataTable>
          <Dialog
            :visible="publicarItemDialog"
            :style="{ width: '450px' }"
            header="Confirmación de publicación"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="item"
                >Esta seguro que desea publicar el artículo seleccionado?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="publicarItemDialog = false"
                name="cancelar"
              />
              <Button
                label="Si"
                icon="pi pi-check"
                class="p-button-text"
                @click="publicarArticulo"
                name="aceptar"
              />
            </template>
          </Dialog>
          <Dialog
            :visible="despublicarItemDialog"
            :style="{ width: '450px' }"
            header="Confirmación de despublicación"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="item"
                >Esta seguro que desea despublicar el artículo
                seleccionado?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="despublicarItemDialog = false"
                name="cancelar"
              />
              <Button
                label="Si"
                icon="pi pi-check"
                class="p-button-text"
                @click="despublicarArticulo"
                name="aceptar"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArticulosService from "../service/articulos.service";
export default {
  metaInfo: {
    title: 'Backoffice - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Backoffice - QualityCare',
        content: 'Administración del sitio web',
      },
    ],
  },
  data() {
    return {
      articulosService: null,
      filters: {},
      item: {},
      itemsList: [],
      publicarItemDialog: false,
      despublicarItemDialog: false,
      loading: false,
    };
  },
  created() {
    this.articulosService = new ArticulosService();
  },
  mounted() {
    this.recuperarItemsForList();
  },
  methods: {
    recuperarItemsForList() {
      this.loading = true;
      this.articulosService
        .getArticuloByIdForAdmin()
        .then((result) => {
          if (result.data.data) {
            this.itemsList = [...result.data.data];
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al cargar los artículos",
            life: 3000,
          });
          this.loading = false;
        });
    },
    confirmPublicarItem(item) {
      this.item = item;
      this.publicarItemDialog = true;
    },
    confirmDesPublicarItem(item) {
      this.item = item;
      this.despublicarItemDialog = true;
    },
    publicarArticulo() {
      this.articulosService
        .togglePublicarArticulo({ id: this.item.id, publicado: 1 })
        .then((response) => {
          console.log("Articulo publicado", response);
          if(response.data.status!=200){
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.errores.length>0 ? response.data.errores[0] : response.data.mensaje,
              life: 3000,
            });
            this.publicarItemDialog = false;
            this.item = {};
            return;
          }
          this.publicarItemDialog = false;
          this.itemsList.map((item) => {
            if (item.id == this.item.id) {
              item.publicado = 1;
            }
          });
          this.item = {};
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: "Artículo publicado",
            life: 3000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    despublicarArticulo() {
      this.articulosService
        .togglePublicarArticulo({ id: this.item.id, publicado: 0 })
        .then(() => {
          this.despublicarItemDialog = false;
          this.itemsList.map((item) => {
            if (item.id == this.item.id) {
              item.publicado = 0;
            }
          });
          this.item = {};
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: "Artículo despublicado, ya no sera visible por el público",
            life: 3000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    revisarItem(data) {
      this.$router.push({ name: "revisar_articulo", params: { id: data.id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.tituloUsuarios {
  font-size: 28px;
  font-weight: 400;
  margin-right: 50px;
}
.muyLargo {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 40em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
        }
      }
    }
  }
}
</style>
